import React__default from 'react';
import { Box, InputBase, CircularProgress, Link, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import DefaultIcon from '../../DefaultIcon/index.js';
import KButton from '../../KButtons/index.js';

var PREFIX = "PublicShareEntryPoint";
var classes = {
    entryPointContainer: "".concat(PREFIX, "-entryPointContainer"),
    entryPoint: "".concat(PREFIX, "-entryPoint"),
    entryPointButton: "".concat(PREFIX, "-entryPointButton"),
    shareLink: "".concat(PREFIX, "-shareLink")
};
var StyledShareEntryPoint = styled(Box)(function (_a) {
    var _b, _c;
    var theme = _a.theme;
    return (_b = {},
        _b["& .".concat(classes.entryPointContainer)] = {
            display: "grid",
            gridTemplateAreas: "\"input button\"",
            gridTemplateColumns: "auto max-content",
            border: "1px solid",
            borderRadius: theme.shape.borderRadius,
            borderColor: theme.palette.grey[400]
        },
        _b["& .".concat(classes.entryPoint)] = {
            gridArea: "input",
            paddingLeft: theme.spacing(1),
            color: theme.palette.common.black,
            "& input": {
                textOverflow: "ellipsis"
            }
        },
        _b["& .".concat(classes.entryPointButton)] = {
            gridArea: "button",
            border: "none",
            margin: 0,
            paddingInline: theme.spacing(1),
            minWidth: "36px",
            "& span": {
                margin: 0
            }
        },
        _b["& .".concat(classes.shareLink)] = (_c = {
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
            },
            _c[theme.breakpoints.down("sm")] = {
                marginLeft: theme.spacing(0)
            },
            _c),
        _b);
});
var labelId = "ShareEntryPoint-input-label";
var ShareEntryPoint = function (_a) {
    var _b = _a.testId, testId = _b === void 0 ? "ShareEntryPoint" : _b, id = _a.id, sx = _a.sx, entryPoint = _a.entryPoint, entryPointInputId = _a.entryPointInputId, loading = _a.loading, shareTitle = _a.shareTitle, copyEntryPoint = _a.copyEntryPoint, disableSocialNetworksLink = _a.disableSocialNetworksLink, _c = _a.KIcon, KIcon = _c === void 0 ? DefaultIcon : _c;
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(StyledShareEntryPoint, { id: id, "data-testid": testId, sx: sx },
        React__default.createElement(Box, { className: classes.entryPointContainer },
            React__default.createElement(InputBase, { id: entryPointInputId, className: classes.entryPoint, value: entryPoint !== null && entryPoint !== void 0 ? entryPoint : "", readOnly: true, fullWidth: true, startAdornment: loading && React__default.createElement(CircularProgress, { size: "1rem" }), inputProps: {
                    "aria-labelledby": labelId,
                    "aria-label": "".concat(t("components.share.link.input.label"))
                } }),
            React__default.createElement(KButton, { onClick: copyEntryPoint, title: t("components.share.link.copy-link.button"), variant: "outlined", startIcon: React__default.createElement(KIcon, { className: "fa-copy" }), className: classes.entryPointButton, disabled: loading, testId: "copyPublicSharedLinkButton" })),
        React__default.createElement(Box, { className: classes.shareLink },
            React__default.createElement(Link, { component: "button", variant: "body2", underline: "none", sx: { paddingRight: function (theme) { return theme.spacing(2.5); } }, onClick: function () {
                    window.open(entryPoint, "_blank", "noopener=true");
                } }, t("components.share.link.open-new-tab.button")),
            React__default.createElement(Link, { underline: "none", sx: {
                    paddingRight: function (theme) { return theme.spacing(2.5); }
                }, href: "mailto:?body=".concat(shareTitle, " ").concat(entryPoint) }, t("components.share.link.email.button")),
            !disableSocialNetworksLink && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(IconButton, { title: t("components.share.link.facebook.button"), "aria-label": t("components.share.link.facebook.button"), sx: {
                        color: function (theme) { return theme.palette.primary.main; },
                        padding: function (theme) { return theme.spacing(0.5); }
                    }, onClick: function () { return window.open("http://www.facebook.com/share.php?u=".concat(entryPoint)); } },
                    React__default.createElement(KIcon, { className: "fa-brands fa-square-facebook", sx: { fontSize: "30px" } })),
                React__default.createElement(IconButton, { title: t("components.share.link.twitter.button"), "aria-label": t("components.share.link.twitter.button"), sx: {
                        color: function (theme) { return theme.palette.primary.main; },
                        padding: function (theme) { return theme.spacing(0.5); }
                    }, onClick: function () {
                        return window.open("https://twitter.com/intent/tweet?text=".concat(shareTitle, "&url=").concat(entryPoint));
                    } },
                    React__default.createElement(KIcon, { className: "fa-brands fa-square-x-twitter", sx: { fontSize: "30px" } })),
                React__default.createElement(IconButton, { title: t("components.share.link.linkedin.button"), "aria-label": t("components.share.link.linkedin.button"), sx: {
                        color: function (theme) { return theme.palette.primary.main; },
                        padding: function (theme) { return theme.spacing(0.5); }
                    }, onClick: function () {
                        return window.open("https://www.linkedin.com/sharing/share-offsite/?url=".concat(entryPoint));
                    } },
                    React__default.createElement(KIcon, { className: "fa-brands fa-linkedin", sx: { fontSize: "30px" } })))))));
};

export { ShareEntryPoint as default };
//# sourceMappingURL=index.js.map
